//
//
//

const ast = require('./ast.js');
const isa = require('./isa.js');



function emitter(code) {
  var res = {
    error: false,
    message: "",
    buf: []
  };


  function push(opcode, data) {
    let instruction = {
      op: opcode,
      data: data
    }

    res.buf.push(instruction);
  }
  
  // TODO - check types as binary and check symbol name exists, move string to type conversion here
  function walktree(node) {
    if (node.nodeType === ast.NODETYPE_NUMBER) {
      push(isa.PUSH_VAL, node.numVal);
    } else if (node.nodeType === ast.NODETYPE_DATE) {
      push(isa.PUSH_VAL, node.dateVal);
    } else if (node.nodeType ===  ast.NODETYPE_IDENT) {
      // at the moment this instruction resolves to pushing data[ident]
      // data happens to be known but really should push data and ident
      // and resolve them as a generic array indexing problem
      push(isa.PUSH_DATA_INDEX, node.ident);
    } else if (node.nodeType === ast.NODETYPE_FUNCTION) {
    } else if (node.nodeType === ast.NODETYPE_BINARY) {
      walktree(node.left);
      walktree(node.right);
      push(isa.PROC_BINARY, node.type); // binary op type
    } else if (node.nodeType === ast.NODETYPE_MODRULE) {
      
    }
  }
  
  walktree(code.expr);

  return res;
}

module.exports.emitter = emitter;
